import { createStore } from 'vuex'

import { adaptiveObjectStore } from './modules/adaptiveobject.store'
import { adminStore } from './modules/admin.store'
import { administrationStore } from './modules/administration.store'
import { agentStore } from './modules/agent.store'
import { assignmentStore } from './modules/assignment.store'
import { auxStore } from './modules/misc.store'
import { chatStore } from './modules/chat.store'
import { conferenceStore } from './modules/conference.store'
import { courseStore } from './modules/course.store'
import { externalLinkStore } from './modules/externallink.store'
import { interactiveContentStore } from './modules/interactivecontent.store'
import { flashcardsStore } from './modules/flashcards.store'
import { filesStore } from './modules/files.store'
import { generalStore } from './modules/general.store'
import { groupStore } from './modules/group.store'
import { geogebraStore } from './modules/geogebra.store'
import { materialStore } from './modules/material.store'
import { mediaStore } from './modules/media.store'
import { messagesStore } from './modules/messages.store'
import { newsStore } from './modules/news.store'
import { notificationStore } from './modules/notifications.store'
import { questionnaireStore } from './modules/questionnaire.store'
import { quizStore } from './modules/quiz.store'
import { profileStore } from './modules/profile.store'
import { rawtextStore } from './modules/rawtext.store'
import { statisticsStore } from './modules/statistics.store'
import { timelineStore } from './modules/timeline.store'
import { userStore } from './modules/user.store'
import { userCommentStore } from './modules/userComment.store'
import { counsellorStore } from './modules/counsellor.store'
import { boardStore } from './modules/board.store'
import { consultationStore } from './modules/consultation.store'
import { subscriptionsStore } from './modules/subscriptions.store'
import { talkStore } from './modules/talk.store'
import groupCopyStore from './modules/groupCopy.store'

// Vue 3 migration Phase 5a: vuex@4 dropped the global `Vue.use(Vuex)` install.
// The store is created via `createStore` and registered on the app via
// `app.use(store)` (see main.js bootstrap). `mapState`/`mapGetters`/
// `mapActions`/`mapMutations` continue working unchanged in vuex@4 — the
// 1,181 call sites need no changes.
const debug = (import.meta.env.MODE !== 'production')

export default createStore({
    modules: {
        adaptiveObjectStore,
        adminStore,
        administrationStore,
        agentStore,
        assignmentStore,
        auxStore,
        chatStore,
        conferenceStore,
        courseStore,
        externalLinkStore,
        interactiveContentStore,
        flashcardsStore,
        filesStore,
        generalStore,
        groupStore,
        geogebraStore,
        materialStore,
        mediaStore,
        messagesStore,
        newsStore,
        notificationStore,
        questionnaireStore,
        quizStore,
        profileStore,
        rawtextStore,
        statisticsStore,
        timelineStore,
        userStore,
        userCommentStore,
        counsellorStore,
        boardStore,
        consultationStore,
        subscriptionsStore,
        talkStore,
        groupCopyStore
    },
    strict: debug
})
